export const resetCookies = (cookies) => {
  cookies.remove("TOKEN", { path: "/" });
  cookies.remove("COMPANY", { path: "/" });
  cookies.remove("EMAIL", { path: "/" });
  cookies.remove("USERNAME", { path: "/" });
  cookies.remove("ID", { path: "/" });
  cookies.remove("ADMIN", { path: "/" });
  return;
};
